import { createElement } from "../../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "../../../../DataBuilders/IContentBuilder";
/**
 * Inline tlačítko pro buňku. Tlačítko během provádění akce zobrazuje uvnitř sebe loader.
 */
export class InlineBtnWithLoaderBuilder implements IContentBuilder {
    private _loaderElement!: HTMLElement;
    private _element!: HTMLElement;
    private readonly _innerContent: HTMLElement;
    private readonly _loaderDefaultOn: boolean;
    private _initialInnerContentVisibility: string | undefined = undefined;

    /**Akce tlačítka*/
    public updateAction!: (element: HTMLElement) => void;

    /**HTML element reprezentující tlačítko*/
    public get element(): HTMLElement {
        return this._element;
    }

    /**
     * Vytváří instanci inline tlačítka s loaderem.
     * @param innerContent Komponenta reprezentující vzhled tlačítka (ikona, popisek, ...)
     * @param loaderDefaultOn Pokud je nastaveno true, komponenta zobrazí loader ihned po vytvoření.
     */
    constructor(innerContent: HTMLElement, loaderDefaultOn: boolean = false) {
        this._innerContent = innerContent;
        this._loaderDefaultOn = loaderDefaultOn;
    }

    private _build(): void {
        if (this._element)
            return;
        this._element = createElement({ classes: ["inline-btn", "loader-enabled", "selected-only"] }); //todo remove selected-only
        if (this._innerContent)
            this._element.appendChild(this._innerContent);
        if (this._loaderDefaultOn)
            this._showLoader();
    }

    protected _createLoader(): HTMLElement {
        const loaderElement = createElement({ classes: "ElementLoader", css: { display: "none" } });
        const loader = createElement({ classes: "loader" });
        loaderElement.appendChild(loader);

        const right = createElement({ classes: "right" });
        right.appendChild(createElement({ classes: "border" }));
        loader.appendChild(right);

        const left = createElement({ classes: "left" });
        left.appendChild(createElement({ classes: "border" }));
        loader.appendChild(left);

        return loaderElement;
    }

    public showLoader(): void {
        this._showLoader();
    }

    public hideLoader(): void {
        this._hideLoader();
    }

    protected _showLoader(): void {
        this._element.classList.toggle("loading", true);
        if (this._innerContent) {
            if (this._initialInnerContentVisibility === undefined) { // Funkce _showLoader se může volat víckrát, proto je potřeba provést kontrolu, že se jedná o první volání. V opačném případě by se při druhém volání funkce mohla proměnná this._initialInnerContentVisibility nastavit na nechtěnou hodnotu.
                this._initialInnerContentVisibility = this._innerContent.style.visibility;
            }
            this._innerContent.style.visibility = "hidden";
        }
        if (!this._loaderElement) {
            this._loaderElement = this._createLoader();
            this._element.appendChild(this._loaderElement);
        }

        if (this._loaderElement)
            this._loaderElement.style.display = "";
    }

    protected _hideLoader(): void {
        this._element.classList.toggle("loading", false);
        if (this._innerContent)
            this._innerContent.style.visibility = this._initialInnerContentVisibility || "inherit";
        if (this._loaderElement)
            this._loaderElement.style.display = "none";
    }

    /**
     * Indikuje, zda právě probíhá akce tlačítka.
     */
    public isLoading(): boolean {
        return this._loaderElement != null && this._loaderElement.style.display !== "none";
    }

    /**
     * Sestaví a vrací tlačítko.
     */
    public async build(): Promise<HTMLElement> {
        await this._build();
        return this._element;
    }

    /**
     * Spustí akci tlačítka - počká na dokončení akce
     */
    public async update(): Promise<void> {
        this._showLoader();
        try {
            await this.updateAction(this._element);
        } finally {
            this._hideLoader();
        }
    }
}
